import React from "react";

export default function SendFeedbackButton({ onClick }) {
  return (
    <button className="btn btn-default btn-lg joystix btn-block" data-testid="send-feedback-button" type="button" onClick={onClick}>
      <span className="fa fa-comment" /> Send feedback
    </button>
  );
}
